module.exports = __webpack_public_path__ + "static/david-a2-c74725e049daa9a61b0659e81426f09f.png";